// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkDownloadPing-cls1_Z8b","cls2":"BulkDownloadPing-cls2_ZSz BulkDownloadPing-cls1_Z8b"};